// Copyright 2026, Metropolis Technologies, Inc.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts"
// @generated from file metropolis/engagement/marketing_page/v1/marketing_page.proto (package metropolis.engagement.marketing_page.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Timestamp } from '@bufbuild/protobuf/wkt';
import {
  file_google_protobuf_struct,
  file_google_protobuf_timestamp,
} from '@bufbuild/protobuf/wkt';
import type { DayOfWeek } from '../../../../google/type/dayofweek_pb';
import { file_google_type_dayofweek } from '../../../../google/type/dayofweek_pb';
import type { LatLng } from '../../../../google/type/latlng_pb';
import { file_google_type_latlng } from '../../../../google/type/latlng_pb';
import type { Money } from '../../../../google/type/money_pb';
import { file_google_type_money } from '../../../../google/type/money_pb';
import type { PostalAddress } from '../../../../google/type/postal_address_pb';
import { file_google_type_postal_address } from '../../../../google/type/postal_address_pb';
import type { TimeOfDay } from '../../../../google/type/timeofday_pb';
import { file_google_type_timeofday } from '../../../../google/type/timeofday_pb';
import type { JsonObject, Message } from '@bufbuild/protobuf';

/**
 * Describes the file metropolis/engagement/marketing_page/v1/marketing_page.proto.
 */
export const file_metropolis_engagement_marketing_page_v1_marketing_page: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_google_protobuf_struct,
      file_google_protobuf_timestamp,
      file_google_type_dayofweek,
      file_google_type_latlng,
      file_google_type_money,
      file_google_type_postal_address,
      file_google_type_timeofday,
    ],
  );

/**
 * Marketing page resource.
 *
 * Acts as a wrapper around a typed page content, modeled as a oneof so each
 * page type carries only the data relevant to it. Nearby entities are nested
 * within each type rather than returned as flat parallel arrays.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.MarketingPage
 */
export type MarketingPage = Message<'metropolis.engagement.marketing_page.v1.MarketingPage'> & {
  /**
   * URL-friendly identifier for this marketing page.
   *
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * Page metadata including SEO tags, titles, descriptions, and marketing content.
   * Contains all text content as plain text (no HTML) for cross-platform compatibility.
   * Web clients can generate JSON-LD from this data.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.PageMetadata page_metadata = 2;
   */
  pageMetadata?: PageMetadata;

  /**
   * Typed page content — exactly one variant will be set depending on the marketing page type.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.MarketingPageContent content = 3;
   */
  content?: MarketingPageContent;
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.MarketingPage.
 * Use `create(MarketingPageSchema)` to create a new message.
 */
export const MarketingPageSchema: GenMessage<MarketingPage> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 0);

/**
 * Response for GetMarketingPage RPC.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.GetMarketingPageResponse
 */
export type GetMarketingPageResponse =
  Message<'metropolis.engagement.marketing_page.v1.GetMarketingPageResponse'> & {
    /**
     * The requested marketing page.
     *
     * @generated from field: metropolis.engagement.marketing_page.v1.MarketingPage marketing_page = 1;
     */
    marketingPage?: MarketingPage;
  };

/**
 * Describes the message metropolis.engagement.marketing_page.v1.GetMarketingPageResponse.
 * Use `create(GetMarketingPageResponseSchema)` to create a new message.
 */
export const GetMarketingPageResponseSchema: GenMessage<GetMarketingPageResponse> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 1);

/**
 * Wrapper around the typed page content.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.MarketingPageContent
 */
export type MarketingPageContent =
  Message<'metropolis.engagement.marketing_page.v1.MarketingPageContent'> & {
    /**
     * @generated from oneof metropolis.engagement.marketing_page.v1.MarketingPageContent.type
     */
    type:
      | {
          /**
           * @generated from field: metropolis.engagement.marketing_page.v1.LocationPage location = 1;
           */
          value: LocationPage;
          case: 'location';
        }
      | {
          /**
           * @generated from field: metropolis.engagement.marketing_page.v1.VenuePage venue = 2;
           */
          value: VenuePage;
          case: 'venue';
        }
      | {
          /**
           * @generated from field: metropolis.engagement.marketing_page.v1.EventPage event = 3;
           */
          value: EventPage;
          case: 'event';
        }
      | {
          /**
           * @generated from field: metropolis.engagement.marketing_page.v1.ZonePage zone = 4;
           */
          value: ZonePage;
          case: 'zone';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message metropolis.engagement.marketing_page.v1.MarketingPageContent.
 * Use `create(MarketingPageContentSchema)` to create a new message.
 */
export const MarketingPageContentSchema: GenMessage<MarketingPageContent> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 2);

/**
 * Marketing page content for a parking location.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.LocationPage
 */
export type LocationPage = Message<'metropolis.engagement.marketing_page.v1.LocationPage'> & {
  /**
   * The primary parking location for this page.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.SiteGroup location = 1;
   */
  location?: SiteGroup;

  /**
   * Nearby events relevant to this location (e.g. events at adjacent venues).
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.Event nearby_events = 2;
   */
  nearbyEvents: Event[];

  /**
   * Other nearby parking locations.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.SiteGroup nearby_locations = 3;
   */
  nearbyLocations: SiteGroup[];
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.LocationPage.
 * Use `create(LocationPageSchema)` to create a new message.
 */
export const LocationPageSchema: GenMessage<LocationPage> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 3);

/**
 * Marketing page content for a venue.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.VenuePage
 */
export type VenuePage = Message<'metropolis.engagement.marketing_page.v1.VenuePage'> & {
  /**
   * The primary venue for this page.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.Venue venue = 1;
   */
  venue?: Venue;

  /**
   * Events scheduled at this venue.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.Event events = 2;
   */
  events: Event[];

  /**
   * Nearby parking locations for this venue.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.SiteGroup nearby_locations = 3;
   */
  nearbyLocations: SiteGroup[];

  /**
   * Parking zones linked to this venue.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.Zone nearby_zones = 4;
   */
  nearbyZones: Zone[];
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.VenuePage.
 * Use `create(VenuePageSchema)` to create a new message.
 */
export const VenuePageSchema: GenMessage<VenuePage> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 4);

/**
 * Marketing page content for an event.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.EventPage
 */
export type EventPage = Message<'metropolis.engagement.marketing_page.v1.EventPage'> & {
  /**
   * The primary event for this page.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.Event event = 1;
   */
  event?: Event;

  /**
   * The venue hosting this event.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.Venue venue = 2;
   */
  venue?: Venue;

  /**
   * Nearby parking locations for this event.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.SiteGroup nearby_locations = 3;
   */
  nearbyLocations: SiteGroup[];

  /**
   * Parking zones linked to the venue hosting this event.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.Zone nearby_zones = 4;
   */
  nearbyZones: Zone[];
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.EventPage.
 * Use `create(EventPageSchema)` to create a new message.
 */
export const EventPageSchema: GenMessage<EventPage> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 5);

/**
 * Marketing page content for a parking zone.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.ZonePage
 */
export type ZonePage = Message<'metropolis.engagement.marketing_page.v1.ZonePage'> & {
  /**
   * The primary parking zone for this page.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.Zone zone = 1;
   */
  zone?: Zone;

  /**
   * Nearby parking zones.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.Zone nearby_zones = 2;
   */
  nearbyZones: Zone[];
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.ZonePage.
 * Use `create(ZonePageSchema)` to create a new message.
 */
export const ZonePageSchema: GenMessage<ZonePage> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 6);

/**
 * SEO and page metadata for marketing pages.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.PageMetadata
 */
export type PageMetadata = Message<'metropolis.engagement.marketing_page.v1.PageMetadata'> & {
  /**
   * HTML page title for SEO (displayed in browser tab and search results).
   *
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * Meta description for SEO (displayed in search engine snippets).
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * Page type identifier.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.MarketingPageType type = 3;
   */
  type: MarketingPageType;

  /**
   * Canonical URL to prevent duplicate content issues.
   *
   * @generated from field: string canonical_url = 4;
   */
  canonicalUrl: string;

  /**
   * Primary image URL for this page (for social sharing and display).
   *
   * @generated from field: optional string image_url = 5;
   */
  imageUrl?: string;

  /**
   * Open-ended SEO metadata blob (e.g. JSON-LD hints, Open Graph tags, custom fields).
   * Stored and returned as-is; clients are responsible for interpretation.
   *
   * @generated from field: optional google.protobuf.Struct seo = 6;
   */
  seo?: JsonObject;
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.PageMetadata.
 * Use `create(PageMetadataSchema)` to create a new message.
 */
export const PageMetadataSchema: GenMessage<PageMetadata> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 7);

/**
 * Event entity representing scheduled events that generate parking demand.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.Event
 */
export type Event = Message<'metropolis.engagement.marketing_page.v1.Event'> & {
  /**
   * Unique identifier for the event.
   *
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * Display name of the event.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * When the event starts.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * When the event ends.
   *
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * ID of the venue where this event takes place.
   *
   * @generated from field: string venue_id = 5;
   */
  venueId: string;

  /**
   * Detailed description of the event.
   *
   * @generated from field: optional string description = 6;
   */
  description?: string;

  /**
   * URL-safe slug for the event's marketing page. Empty when no marketing page
   * exists for this event yet. Used by clients to build canonical nested links
   * (e.g. a VenuePage's events list linking to per-event marketing pages).
   *
   * @generated from field: string slug = 7;
   */
  slug: string;

  /**
   * Minimum cascade-resolved reservation rate across all zones linked to this
   * event's venue. Populated from market-service's
   * ListEventStartingRatesForVenue RPC, which resolves each (event, zone) pair
   * via the EventVenueZonePricing override -> VenueZonePricing venue default
   * cascade and takes min() across zones.
   *
   * Absent when no rate is configured for the event across any linked zone —
   * clients should treat absence as "rate not configured" rather than "$0".
   *
   * @generated from field: google.type.Money rate_starts_at = 8;
   */
  rateStartsAt?: Money;
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 8);

/**
 * Venue entity representing locations that host events.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.Venue
 */
export type Venue = Message<'metropolis.engagement.marketing_page.v1.Venue'> & {
  /**
   * Unique identifier for the venue.
   *
   * @generated from field: string venue_id = 1;
   */
  venueId: string;

  /**
   * Display name of the venue.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Detailed description of the venue.
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Physical address of the venue.
   *
   * @generated from field: optional google.type.PostalAddress address = 4;
   */
  address?: PostalAddress;

  /**
   * Geographic coordinates of the venue.
   *
   * @generated from field: optional google.type.LatLng coordinates = 5;
   */
  coordinates?: LatLng;

  /**
   * Type of venue (stadium, arena, theater, convention_center, etc.).
   *
   * @generated from field: string venue_type = 6;
   */
  venueType: string;

  /**
   * Official website URL for the venue.
   *
   * @generated from field: optional string website_url = 7;
   */
  websiteUrl?: string;

  /**
   * URL-safe slug for the venue's marketing page. Empty when no marketing page
   * exists for this venue yet. Used by clients to build canonical nested links
   * (e.g. an EventPage's `venue` field linking to the per-venue marketing page).
   *
   * @generated from field: string slug = 8;
   */
  slug: string;
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.Venue.
 * Use `create(VenueSchema)` to create a new message.
 */
export const VenueSchema: GenMessage<Venue> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 9);

/**
 * Physical characteristics of a parking zone.
 * Based on site-config's PhysicalCharacteristics message, adapted for this API.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.PhysicalCharacteristics
 */
export type PhysicalCharacteristics =
  Message<'metropolis.engagement.marketing_page.v1.PhysicalCharacteristics'> & {
    /**
     * Physical structure of the parking facility (garage, lot, stand, etc.).
     *
     * @generated from field: metropolis.engagement.marketing_page.v1.PhysicalCharacteristics.StructureType structure_type = 1;
     */
    structureType: PhysicalCharacteristics_StructureType;

    /**
     * Internet connectivity available at the site.
     *
     * @generated from field: metropolis.engagement.marketing_page.v1.PhysicalCharacteristics.InternetAvailability internet_availability = 2;
     */
    internetAvailability: PhysicalCharacteristics_InternetAvailability;

    /**
     * Total square footage of the parking area.
     *
     * @generated from field: uint32 square_feet = 3;
     */
    squareFeet: number;

    /**
     * Number of vehicle capture units (VCUs) installed.
     *
     * @generated from field: uint32 vcu_count = 4;
     */
    vcuCount: number;
  };

/**
 * Describes the message metropolis.engagement.marketing_page.v1.PhysicalCharacteristics.
 * Use `create(PhysicalCharacteristicsSchema)` to create a new message.
 */
export const PhysicalCharacteristicsSchema: GenMessage<PhysicalCharacteristics> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 10);

/**
 * Physical structure of the parking facility.
 *
 * @generated from enum metropolis.engagement.marketing_page.v1.PhysicalCharacteristics.StructureType
 */
export enum PhysicalCharacteristics_StructureType {
  /**
   * @generated from enum value: STRUCTURE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STRUCTURE_TYPE_GARAGE = 1;
   */
  GARAGE = 1,

  /**
   * @generated from enum value: STRUCTURE_TYPE_LOT = 2;
   */
  LOT = 2,

  /**
   * @generated from enum value: STRUCTURE_TYPE_STAND = 3;
   */
  STAND = 3,

  /**
   * @generated from enum value: STRUCTURE_TYPE_EVENT = 4;
   */
  EVENT = 4,

  /**
   * @generated from enum value: STRUCTURE_TYPE_OTHER = 5;
   */
  OTHER = 5,
}

/**
 * Describes the enum metropolis.engagement.marketing_page.v1.PhysicalCharacteristics.StructureType.
 */
export const PhysicalCharacteristics_StructureTypeSchema: GenEnum<PhysicalCharacteristics_StructureType> =
  /*@__PURE__*/
  enumDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 10, 0);

/**
 * Internet connectivity available at the site.
 *
 * @generated from enum metropolis.engagement.marketing_page.v1.PhysicalCharacteristics.InternetAvailability
 */
export enum PhysicalCharacteristics_InternetAvailability {
  /**
   * @generated from enum value: INTERNET_AVAILABILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTERNET_AVAILABILITY_CELLULAR = 1;
   */
  CELLULAR = 1,

  /**
   * @generated from enum value: INTERNET_AVAILABILITY_WIRED = 2;
   */
  WIRED = 2,

  /**
   * @generated from enum value: INTERNET_AVAILABILITY_NONE = 3;
   */
  NONE = 3,
}

/**
 * Describes the enum metropolis.engagement.marketing_page.v1.PhysicalCharacteristics.InternetAvailability.
 */
export const PhysicalCharacteristics_InternetAvailabilitySchema: GenEnum<PhysicalCharacteristics_InternetAvailability> =
  /*@__PURE__*/
  enumDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 10, 1);

/**
 * Individual parking zone entity.
 * Contains operational details and availability information.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.Zone
 */
export type Zone = Message<'metropolis.engagement.marketing_page.v1.Zone'> & {
  /**
   * Unique identifier for this parking zone.
   *
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * Legacy API ID for backwards compatibility.
   *
   * @generated from field: uint64 site_api_id = 2;
   */
  siteApiId: bigint;

  /**
   * Public display name of the parking zone.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Current operational status.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.Zone.Status status = 4;
   */
  status: Zone_Status;

  /**
   * Operating hours for each day of the week.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.OperatingHours operating_hours = 5;
   */
  operatingHours: OperatingHours[];

  /**
   * What types of customers are allowed.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.Zone.ConsumerType consumer_type = 6;
   */
  consumerType: Zone_ConsumerType;

  /**
   * Internal name for operational use.
   *
   * @generated from field: string internal_name = 7;
   */
  internalName: string;

  /**
   * How parking is operated (self-park, valet, etc.).
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.Zone.SiteMode site_mode = 8;
   */
  siteMode: Zone_SiteMode;

  /**
   * Type of business this parking serves.
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.Zone.AssetProfile asset_profile = 9;
   */
  assetProfile: Zone_AssetProfile;

  /**
   * Physical address of the parking zone.
   *
   * @generated from field: optional google.type.PostalAddress address = 10;
   */
  address?: PostalAddress;

  /**
   * Geographic coordinates of the parking zone.
   *
   * @generated from field: optional google.type.LatLng coordinates = 11;
   */
  coordinates?: LatLng;

  /**
   * Human-readable distance from reference point.
   *
   * @generated from field: optional string distance = 12;
   */
  distance?: string;

  /**
   * Physical characteristics (structure type, square footage, etc.).
   *
   * @generated from field: metropolis.engagement.marketing_page.v1.PhysicalCharacteristics physical_characteristics = 13;
   */
  physicalCharacteristics?: PhysicalCharacteristics;

  /**
   * Vehicle height clearance (e.g. "7'2\""). Absent if not recorded in survey data.
   *
   * @generated from field: optional string height_clearance = 14;
   */
  heightClearance?: string;

  /**
   * Available amenities at this parking zone.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.Zone.Amenity amenities = 15;
   */
  amenities: Zone_Amenity[];

  /**
   * Payment methods accepted at this parking zone.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.Zone.AcceptedPayment accepted_payments = 16;
   */
  acceptedPayments: Zone_AcceptedPayment[];

  /**
   * Whether first party reservations are enabled for this parking zone.
   *
   * @generated from field: bool first_party_reservations_enabled = 17;
   */
  firstPartyReservationsEnabled: boolean;

  /**
   * URL-friendly slug for this zone's marketing page (e.g. "305-w-ontario-st-chicago-il").
   * Populated only on entries within ZonePage.nearby_zones. Empty when the nearby zone has no
   * marketing page row yet — clients must handle the empty-string case (typically by hiding the
   * navigation link rather than constructing an invalid URL). Never set on the primary zone
   * returned by GetMarketingPage.
   *
   * @generated from field: string slug = 18;
   */
  slug: string;
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.Zone.
 * Use `create(ZoneSchema)` to create a new message.
 */
export const ZoneSchema: GenMessage<Zone> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 11);

/**
 * Current operational status of the parking zone.
 *
 * @generated from enum metropolis.engagement.marketing_page.v1.Zone.Status
 */
export enum Zone_Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Zone being set up, not yet operational
   *
   * @generated from enum value: STATUS_ONBOARDING = 3;
   */
  ONBOARDING = 3,

  /**
   * Zone is operational and accepting customers
   *
   * @generated from enum value: STATUS_ACTIVE = 4;
   */
  ACTIVE = 4,

  /**
   * Zone is temporarily or permanently closed
   *
   * @generated from enum value: STATUS_INACTIVE = 5;
   */
  INACTIVE = 5,
}

/**
 * Describes the enum metropolis.engagement.marketing_page.v1.Zone.Status.
 */
export const Zone_StatusSchema: GenEnum<Zone_Status> =
  /*@__PURE__*/
  enumDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 11, 0);

/**
 * Types of customers this zone serves.
 *
 * @generated from enum metropolis.engagement.marketing_page.v1.Zone.ConsumerType
 */
export enum Zone_ConsumerType {
  /**
   * @generated from enum value: CONSUMER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Both visitors and subscribers welcome
   *
   * @generated from enum value: CONSUMER_TYPE_VISITOR_SUBSCRIBER = 1;
   */
  VISITOR_SUBSCRIBER = 1,

  /**
   * Visitors only (no subscriptions)
   *
   * @generated from enum value: CONSUMER_TYPE_VISITOR = 2;
   */
  VISITOR = 2,

  /**
   * Subscribers only (no transient parking)
   *
   * @generated from enum value: CONSUMER_TYPE_SUBSCRIBER = 3;
   */
  SUBSCRIBER = 3,
}

/**
 * Describes the enum metropolis.engagement.marketing_page.v1.Zone.ConsumerType.
 */
export const Zone_ConsumerTypeSchema: GenEnum<Zone_ConsumerType> =
  /*@__PURE__*/
  enumDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 11, 1);

/**
 * Parking operation mode.
 *
 * @generated from enum metropolis.engagement.marketing_page.v1.Zone.SiteMode
 */
export enum Zone_SiteMode {
  /**
   * @generated from enum value: SITE_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Customers park themselves
   *
   * @generated from enum value: SITE_MODE_SELF_PARK = 1;
   */
  SELF_PARK = 1,

  /**
   * Valet service only
   *
   * @generated from enum value: SITE_MODE_VALET = 2;
   */
  VALET = 2,

  /**
   * Both self-park and valet available
   *
   * @generated from enum value: SITE_MODE_COMBO = 3;
   */
  COMBO = 3,

  /**
   * Manual operation, no technology
   *
   * @generated from enum value: SITE_MODE_NO_TECH = 4;
   */
  NO_TECH = 4,
}

/**
 * Describes the enum metropolis.engagement.marketing_page.v1.Zone.SiteMode.
 */
export const Zone_SiteModeSchema: GenEnum<Zone_SiteMode> =
  /*@__PURE__*/
  enumDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 11, 2);

/**
 * Type of business/location this parking serves.
 *
 * @generated from enum metropolis.engagement.marketing_page.v1.Zone.AssetProfile
 */
export enum Zone_AssetProfile {
  /**
   * @generated from enum value: ASSET_PROFILE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_PROFILE_AIRPORT = 1;
   */
  AIRPORT = 1,

  /**
   * @generated from enum value: ASSET_PROFILE_CASINO = 2;
   */
  CASINO = 2,

  /**
   * @generated from enum value: ASSET_PROFILE_CHURCH = 3;
   */
  CHURCH = 3,

  /**
   * @generated from enum value: ASSET_PROFILE_COMMERCIAL_OFFICE = 4;
   */
  COMMERCIAL_OFFICE = 4,

  /**
   * @generated from enum value: ASSET_PROFILE_CONSULTING = 5;
   */
  CONSULTING = 5,

  /**
   * @generated from enum value: ASSET_PROFILE_ENTERTAINMENT = 6;
   */
  ENTERTAINMENT = 6,

  /**
   * @generated from enum value: ASSET_PROFILE_GOVERNMENT = 7;
   */
  GOVERNMENT = 7,

  /**
   * @generated from enum value: ASSET_PROFILE_HEALTHCARE = 8;
   */
  HEALTHCARE = 8,

  /**
   * @generated from enum value: ASSET_PROFILE_HOSPITALITY = 9;
   */
  HOSPITALITY = 9,

  /**
   * @generated from enum value: ASSET_PROFILE_MIXED_USE = 10;
   */
  MIXED_USE = 10,

  /**
   * @generated from enum value: ASSET_PROFILE_MULTI_FAMILY = 11;
   */
  MULTI_FAMILY = 11,

  /**
   * @generated from enum value: ASSET_PROFILE_OFF_AIRPORT = 12;
   */
  OFF_AIRPORT = 12,

  /**
   * @generated from enum value: ASSET_PROFILE_OTHER = 13;
   */
  OTHER = 13,

  /**
   * @generated from enum value: ASSET_PROFILE_RESIDENTIAL = 14;
   */
  RESIDENTIAL = 14,

  /**
   * @generated from enum value: ASSET_PROFILE_RESTAURANT = 15;
   */
  RESTAURANT = 15,

  /**
   * @generated from enum value: ASSET_PROFILE_RETAIL = 16;
   */
  RETAIL = 16,

  /**
   * @generated from enum value: ASSET_PROFILE_SCHOOL = 17;
   */
  SCHOOL = 17,

  /**
   * @generated from enum value: ASSET_PROFILE_SPECIAL_EVENT = 18;
   */
  SPECIAL_EVENT = 18,

  /**
   * @generated from enum value: ASSET_PROFILE_STADIUM_ARENA = 19;
   */
  STADIUM_ARENA = 19,

  /**
   * @generated from enum value: ASSET_PROFILE_STAND_ALONE_PARKING = 20;
   */
  STAND_ALONE_PARKING = 20,

  /**
   * @generated from enum value: ASSET_PROFILE_TRANSPORTATION = 21;
   */
  TRANSPORTATION = 21,

  /**
   * @generated from enum value: ASSET_PROFILE_UNIVERSITY = 22;
   */
  UNIVERSITY = 22,
}

/**
 * Describes the enum metropolis.engagement.marketing_page.v1.Zone.AssetProfile.
 */
export const Zone_AssetProfileSchema: GenEnum<Zone_AssetProfile> =
  /*@__PURE__*/
  enumDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 11, 3);

/**
 * Available amenities at the zone.
 *
 * @generated from enum metropolis.engagement.marketing_page.v1.Zone.Amenity
 */
export enum Zone_Amenity {
  /**
   * @generated from enum value: AMENITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AMENITY_VALET = 1;
   */
  VALET = 1,

  /**
   * @generated from enum value: AMENITY_COVERED = 2;
   */
  COVERED = 2,

  /**
   * @generated from enum value: AMENITY_EV_CHARGING = 3;
   */
  EV_CHARGING = 3,

  /**
   * @generated from enum value: AMENITY_WHEELCHAIR_ACCESSIBLE = 4;
   */
  WHEELCHAIR_ACCESSIBLE = 4,

  /**
   * @generated from enum value: AMENITY_PUBLIC_RESTROOM = 5;
   */
  PUBLIC_RESTROOM = 5,

  /**
   * @generated from enum value: AMENITY_ON_SITE_STAFF = 6;
   */
  ON_SITE_STAFF = 6,

  /**
   * @generated from enum value: AMENITY_IN_OUT_ACCESS = 7;
   */
  IN_OUT_ACCESS = 7,

  /**
   * @generated from enum value: AMENITY_BATTERY_JUMP = 8;
   */
  BATTERY_JUMP = 8,

  /**
   * @generated from enum value: AMENITY_TIRE_INFLATION = 9;
   */
  TIRE_INFLATION = 9,
}

/**
 * Describes the enum metropolis.engagement.marketing_page.v1.Zone.Amenity.
 */
export const Zone_AmenitySchema: GenEnum<Zone_Amenity> =
  /*@__PURE__*/
  enumDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 11, 4);

/**
 * Accepted payment methods at the zone.
 *
 * @generated from enum metropolis.engagement.marketing_page.v1.Zone.AcceptedPayment
 */
export enum Zone_AcceptedPayment {
  /**
   * @generated from enum value: ACCEPTED_PAYMENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCEPTED_PAYMENT_VISA = 1;
   */
  VISA = 1,

  /**
   * @generated from enum value: ACCEPTED_PAYMENT_MASTERCARD = 2;
   */
  MASTERCARD = 2,

  /**
   * @generated from enum value: ACCEPTED_PAYMENT_AMEX = 3;
   */
  AMEX = 3,

  /**
   * @generated from enum value: ACCEPTED_PAYMENT_DISCOVER = 4;
   */
  DISCOVER = 4,
}

/**
 * Describes the enum metropolis.engagement.marketing_page.v1.Zone.AcceptedPayment.
 */
export const Zone_AcceptedPaymentSchema: GenEnum<Zone_AcceptedPayment> =
  /*@__PURE__*/
  enumDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 11, 5);

/**
 * Parking location entity that groups multiple parking zones.
 * Represents a single physical location with multiple parking areas.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.SiteGroup
 */
export type SiteGroup = Message<'metropolis.engagement.marketing_page.v1.SiteGroup'> & {
  /**
   * Unique identifier for this parking location.
   *
   * @generated from field: string site_group_id = 1;
   */
  siteGroupId: string;

  /**
   * Legacy API ID for backwards compatibility.
   *
   * @generated from field: uint64 site_group_api_id = 2;
   */
  siteGroupApiId: bigint;

  /**
   * Public display name of the parking location.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Operating hours for each day of the week.
   * Individual zones may have different hours.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.OperatingHours operating_hours = 4;
   */
  operatingHours: OperatingHours[];

  /**
   * All parking zones within this location.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.Zone zones = 5;
   */
  zones: Zone[];

  /**
   * Human-readable distance from reference point.
   *
   * @generated from field: optional string distance = 6;
   */
  distance?: string;
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.SiteGroup.
 * Use `create(SiteGroupSchema)` to create a new message.
 */
export const SiteGroupSchema: GenMessage<SiteGroup> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 12);

/**
 * A single contiguous open/close window within a day.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.OpenPeriod
 */
export type OpenPeriod = Message<'metropolis.engagement.marketing_page.v1.OpenPeriod'> & {
  /**
   * Time when this period opens.
   *
   * @generated from field: google.type.TimeOfDay opens_at = 1;
   */
  opensAt?: TimeOfDay;

  /**
   * Time when this period closes.
   *
   * @generated from field: google.type.TimeOfDay closes_at = 2;
   */
  closesAt?: TimeOfDay;
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.OpenPeriod.
 * Use `create(OpenPeriodSchema)` to create a new message.
 */
export const OpenPeriodSchema: GenMessage<OpenPeriod> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 13);

/**
 * Operating hours for a single day, supporting multiple open periods.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.OperatingHours
 */
export type OperatingHours = Message<'metropolis.engagement.marketing_page.v1.OperatingHours'> & {
  /**
   * Day of the week.
   *
   * @generated from field: google.type.DayOfWeek day_of_week = 1;
   */
  dayOfWeek: DayOfWeek;

  /**
   * Open periods for this day, sorted by opens_at.
   * Empty when is_closed or is_24_hours is true.
   *
   * @generated from field: repeated metropolis.engagement.marketing_page.v1.OpenPeriod open_periods = 2;
   */
  openPeriods: OpenPeriod[];

  /**
   * Whether this location is open 24 hours on this day.
   *
   * @generated from field: bool is_24_hours = 3;
   */
  is24Hours: boolean;

  /**
   * Whether this location is closed on this day.
   *
   * @generated from field: bool is_closed = 4;
   */
  isClosed: boolean;
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.OperatingHours.
 * Use `create(OperatingHoursSchema)` to create a new message.
 */
export const OperatingHoursSchema: GenMessage<OperatingHours> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 14);

/**
 * Response containing a page of marketing page summaries.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.ListMarketingPagesResponse
 */
export type ListMarketingPagesResponse =
  Message<'metropolis.engagement.marketing_page.v1.ListMarketingPagesResponse'> & {
    /**
     * Page of marketing page summaries.
     *
     * @generated from field: repeated metropolis.engagement.marketing_page.v1.MarketingPageSummary marketing_pages = 1;
     */
    marketingPages: MarketingPageSummary[];

    /**
     * Pagination metadata.
     *
     * @generated from field: metropolis.engagement.marketing_page.v1.Pagination pagination = 2;
     */
    pagination?: Pagination;
  };

/**
 * Describes the message metropolis.engagement.marketing_page.v1.ListMarketingPagesResponse.
 * Use `create(ListMarketingPagesResponseSchema)` to create a new message.
 */
export const ListMarketingPagesResponseSchema: GenMessage<ListMarketingPagesResponse> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 15);

/**
 * Offset-based pagination metadata.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.Pagination
 */
export type Pagination = Message<'metropolis.engagement.marketing_page.v1.Pagination'> & {
  /**
   * Total number of records for the resource.
   *
   * @generated from field: uint32 total = 1;
   */
  total: number;

  /**
   * Number of records skipped.
   *
   * @generated from field: uint32 offset = 2;
   */
  offset: number;

  /**
   * Number of items fetched.
   *
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message metropolis.engagement.marketing_page.v1.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 16);

/**
 * Lightweight marketing page summary for sitemap generation.
 * Does not include full content — use GetMarketingPage for that.
 *
 * @generated from message metropolis.engagement.marketing_page.v1.MarketingPageSummary
 */
export type MarketingPageSummary =
  Message<'metropolis.engagement.marketing_page.v1.MarketingPageSummary'> & {
    /**
     * Marketing page type.
     *
     * @generated from field: metropolis.engagement.marketing_page.v1.MarketingPageType type = 1;
     */
    type: MarketingPageType;

    /**
     * URL-friendly slug.
     *
     * @generated from field: string slug = 2;
     */
    slug: string;

    /**
     * Canonical URL for use as sitemap <loc>.
     *
     * @generated from field: string canonical_url = 3;
     */
    canonicalUrl: string;

    /**
     * Last modified timestamp for use as sitemap <lastmod>.
     *
     * @generated from field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
  };

/**
 * Describes the message metropolis.engagement.marketing_page.v1.MarketingPageSummary.
 * Use `create(MarketingPageSummarySchema)` to create a new message.
 */
export const MarketingPageSummarySchema: GenMessage<MarketingPageSummary> =
  /*@__PURE__*/
  messageDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 17);

/**
 * Marketing page type enumeration.
 * Values are intentionally lowercase for clean URL path binding
 * (e.g. /v1/marketingPages/event/{slug}).
 *
 * @generated from enum metropolis.engagement.marketing_page.v1.MarketingPageType
 */
export enum MarketingPageType {
  /**
   * @generated from enum value: marketing_page_type_unspecified = 0;
   */
  marketing_page_type_unspecified = 0,

  /**
   * Individual parking locations (SiteGroups)
   *
   * @generated from enum value: location = 1;
   */
  location = 1,

  /**
   * Event venues with associated parking
   *
   * @generated from enum value: venue = 2;
   */
  venue = 2,

  /**
   * Specific events with surrounding parking options
   *
   * @generated from enum value: event = 3;
   */
  event = 3,

  /**
   * Parking zones (individual sites)
   *
   * @generated from enum value: zone = 4;
   */
  zone = 4,
}

/**
 * Describes the enum metropolis.engagement.marketing_page.v1.MarketingPageType.
 */
export const MarketingPageTypeSchema: GenEnum<MarketingPageType> =
  /*@__PURE__*/
  enumDesc(file_metropolis_engagement_marketing_page_v1_marketing_page, 0);
